/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';

import ConfirmDialog from 'components/ConfirmDialog';
import EventTracking from 'lib/EventTracking';

type Props = {
  orgUuid: ?string,
  onConfirm: Function,
  onRequestHide: () => void,
  totalRecipientCount: number,
  scheduled?: boolean,
  eventProperties?: any,
};

class SendUrgentMessageConfirmDialog extends React.Component<Props> {
  // no need to specify this is an urgent message send in the event name
  // because is_urgent is already passed through |eventProperties|
  componentDidMount() {
    EventTracking.trackKey('announcements.composer.confirm_send.view', {
      organization_uuid: this.props.orgUuid,
      ...this.props.eventProperties,
    });
  }

  render() {
    const { totalRecipientCount, onConfirm, onRequestHide, scheduled, orgUuid } = this.props;
    const titleText = scheduled
      ? `Schedule this urgent message to be sent to ${totalRecipientCount} people?`
      : `Send this urgent message to ${totalRecipientCount} people?`;
    const subText = `This message will be sent to all mobile devices. If recipients aren't reachable by mobile, they'll receive a text-to-voice landline call.`;
    return (
      <ConfirmDialog
        title={<span>{titleText}</span>}
        subtext={<span>{subText}</span>}
        onConfirm={onConfirm}
        onRequestHide={onRequestHide}
        actionButtonText={scheduled ? 'Schedule' : 'Send'}
        cancelButtonText="Cancel"
        confirmEventKey="announcements.composer.confirm_send.send.click"
        confirmEventProperties={{
          ...this.props.eventProperties,
          organization_uuid: orgUuid,
        }}
        cancelEventKey="announcements.composer.confirm_send.cancel.click"
        cancelEventProperties={{
          ...this.props.eventProperties,
          organization_uuid: orgUuid,
        }}
      />
    );
  }
}

const mapStateToProps = (state: Object) => {
  return {
    totalRecipientCount: state.roleBasedMessagingSearch.totalRecipientCount,
  };
};

export { SendUrgentMessageConfirmDialog };
export default connect(mapStateToProps)(SendUrgentMessageConfirmDialog);
